<template>
  <el-container class="chat-page" :class="{ 'mobile-fullscreen': isMobileFullscreen }">
    <!-- 🔥 Happy iframe 拖拽捕获层 - 始终存在，通过 class 控制 -->
    <div class="drag-capture-overlay"
         :class="{ 'active': draggedFiles }"></div>

    <el-aside :width="sidebarWidth + 'px'" class="chat-list-box" v-show="!isMobileFullscreen">
      <div class="chat-list-header">
        <div class="app-title">AI版微信-傻蛋IM</div>
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-list-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <!-- 滑动容器 -->
      <div class="chat-list-container" ref="chatListContainer" v-else>
        <!-- 一级列表 (主列表) -->
        <div class="main-list-view" :class="{ 'sliding-out': viewMode === 'agent-list' }">
          <el-scrollbar class="chat-list-items" ref="mainListScrollbar" :class="{ 'hide-scrollbar': agentListAnimating }">
            <div class="chat-item" :class="{ active: activeView === 'verify' }" @click="onActiveVerify()" style="cursor:pointer">
              <div class="chat-left">
                <head-image name="验证" :size="42"></head-image>
                <div v-show="pendingRequestCount > 0" class="unread-text">{{ pendingRequestCount }}</div>
              </div>
              <div class="chat-right">
                <div class="chat-name"><div class="chat-name-text"><div>验证消息</div></div></div>
                <div class="chat-content"><span style="color:#999;font-size:12px">好友与入群申请</span></div>
              </div>
            </div>
            <div v-for="(chat, index) in sortedChats" :key="generateChatKey(chat, index)">
              <chat-item v-show="!chat.delete && chat.showName && chat.showName.includes(searchText)" :chat="chat" :index="chat.originalIndex"
                @click.native="onActiveItem(chat.originalIndex)" @delete="onDelItem(chat)" @top="onTop(chat.originalIndex)"
                @send-files="handleSendFiles"
                :active="isActiveChatItem(chat)"
                :data-chat-index="chat.originalIndex"
                :class="{
                  'terminal-chat': chat.isTerminalChat || chat.isTerminalInbox,
                  'normal-chat': !chat.isTerminalChat && !chat.isTerminalInbox,
                  'agent-aggregate': chat.type === 'AGENT_AGGREGATE'
                }"></chat-item>
            </div>
          </el-scrollbar>
        </div>

        <!-- 二级列表 (智能体列表) -->
        <div class="agent-list-view" :class="{ 'active': viewMode === 'agent-list' }">
          <!-- 返回头部 -->
          <div class="back-header" @click="backToMainView">
            <i class="el-icon-arrow-left"></i>
            <span class="parent-chat-name">智能体</span>
          </div>

          <!-- 智能体列表 -->
          <el-scrollbar class="agent-chat-items" ref="agentListScrollbar" :class="{ 'hide-scrollbar': agentListAnimating }">
            <div v-for="(agentChat, index) in currentAgentChats" :key="generateChatKey(agentChat, index)">
              <chat-item v-show="!agentChat.delete" :chat="agentChat" :index="agentChat.originalIndex"
                @click.native="onActiveItem(agentChat.originalIndex)" @delete="onDelItem(agentChat)" @top="onTop(agentChat.originalIndex)"
                @send-files="handleSendFiles"
                :active="chatStore.activeChat && agentChat.type === chatStore.activeChat.type && agentChat.targetId === chatStore.activeChat.targetId"
                :data-chat-index="agentChat.originalIndex"
                :parent-chat="selectedParentChat"
                class="agent-chat-item"></chat-item>
            </div>

            <!-- 空状态 -->
            <div v-if="currentAgentChats.length === 0" class="empty-agent-guide">
              <div class="empty-icon">🤖</div>
              <div class="empty-text">暂无智能体会话</div>
              <el-button type="primary" size="small" @click="openAgentSidebar" class="add-agent-btn">
                <i class="el-icon-search"></i> 浏览智能体广场
              </el-button>
            </div>
          </el-scrollbar>
        </div>
      </div>

      <!-- 分隔条 -->
      <div
        class="sidebar-resizer"
        @mousedown="handleResizerMouseDown"
        :class="{ 'resizer-dragging': isDragging, 'resizer-hovered': isResizerHovered }"
        @mouseenter="isResizerHovered = true"
        @mouseleave="onResizerMouseLeave"
      >
        <!-- 分割线 - 悬停时显示 -->
        <div class="resizer-line"></div>
        <!-- 三个小点手柄 - 始终显示 -->
        <div class="resizer-handle">
          <div class="resizer-dot"></div>
          <div class="resizer-dot"></div>
          <div class="resizer-dot"></div>
        </div>
      </div>
    </el-aside>
    <el-container class="chat-box" :class="{ 'disable-pointer-events': isDragging }">
      <!-- 容器管理组件 - 云电脑远程工作台 -->
      <container-manager v-if="isPCTerminalChat" ref="containerManager"></container-manager>

      <!-- 数字员工管理面板 - 小龙虾端(本地) -->
      <agent-dashboard v-if="isOpenClawTerminalChat" key="local" ref="agentDashboard" mode="local" @chat-opened="onAgentChatOpened"></agent-dashboard>

      <!-- 数字员工管理面板 - 云小龙虾端 -->
      <agent-dashboard v-if="isCloudOpenClawChat" key="cloud" ref="cloudAgentDashboard" mode="cloud" @chat-opened="onAgentChatOpened"></agent-dashboard>

      <chat-box v-if="chatStore.activeChat && !isOpenClawTerminalChat && !isCloudOpenClawChat && activeView !== 'verify'" :chat="chatStore.activeChat" @message-sent="onMessageSent"></chat-box>
      <access-request-page v-if="activeView === 'verify'" ref="accessRequestPage" @approved="loadPendingCount()"></access-request-page>
    </el-container>
    <!-- 拖拽遮罩层 - 防止 iframe 捕获鼠标事件 -->
    <div v-if="isDragging" class="drag-overlay"></div>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ContainerManager from "../components/chat/ContainerManager.vue";
import AgentDashboard from "../components/agent/AgentDashboard.vue";
import AccessRequestPage from "../components/friend/AccessRequestPage.vue";
import HeadImage from "../components/common/HeadImage.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ContainerManager,
    AgentDashboard,
    AccessRequestPage,
    HeadImage
  },
  data() {
    return {
      searchText: "",
      activeView: "chat",
      pendingRequestCount: 0,
      messageContent: "",
      group: {},
      // 终端间通信相关
      showTerminalSelector: false,
      // PC终端会话检测
      isPCTerminalChat: false,
      // 小龙虾端（OpenClaw数字员工）会话检测
      isOpenClawTerminalChat: false,
      // 云小龙虾端会话检测
      isCloudOpenClawChat: false,
      groupMembers: [],
      // 分隔条拖拽相关
      sidebarWidth: this.getInitialSidebarWidth(),
      isDragging: false,
      isResizerHovered: false,
      dragStartX: 0,
      dragStartWidth: 0,
      animationFrameId: null, // requestAnimationFrame ID
      pendingWidth: null, // 待更新的宽度
      // 智能体两级列表相关
      viewMode: 'main', // 'main' | 'agent-list'
      selectedParentChat: null, // 当前查看智能体列表的父会话
      agentListAnimating: false, // 动画进行中标识
      mainListScrollTop: 0, // 主列表滚动位置缓存
      agentListScrollTop: 0, // 智能体列表滚动位置缓存
      // 拖拽文件缓存（用于跨 iframe 拖拽）
      draggedFiles: null,
      currentHighlightedChatIndex: null, // 🆕 记录当前高亮的会话索引（性能优化）
      // 🔥 智能体初始化状态跟踪
      isHandlingAgentInit: false, // 防止重复调用handleAgentShareLink
      lastHandledAgentId: null // 记录最后处理的agentId，避免重复处理同一个智能体
    }
  },
  methods: {
    async loadPendingCount() {
      try {
        const res = await this.$http({ url: "/access-request/pending", method: "get" });
        this.pendingRequestCount = (res && res.length) || 0;
      } catch(e) { this.pendingRequestCount = 0; }
    },
    onActiveVerify() {
      this.activeView = "verify";
      this.pendingRequestCount = 0;
      this.$nextTick(() => {
        if (this.$refs.accessRequestPage) this.$refs.accessRequestPage.loadRequests();
      });
    },
    // 定位到第一个未读会话
    locateFirstUnreadChat() {
      console.log('[Chat] 定位到第一个未读会话');

      // 如果当前在智能体列表视图，先返回主列表
      if (this.viewMode === 'agent-list') {
        console.log('[Chat] 当前在智能体列表视图，先返回主列表');
        this.backToMainView();
        // 等待动画完成后再定位
        setTimeout(() => {
          this.doLocateFirstUnreadChat();
        }, 450); // 动画时长 + 50ms 缓冲
      } else {
        this.doLocateFirstUnreadChat();
      }
    },

    // 实际执行定位到第一个未读会话
    doLocateFirstUnreadChat() {
      const chats = this.sortedChats;

      // 查找第一个有未读消息的会话
      for (let i = 0; i < chats.length; i++) {
        const chat = chats[i];
        if (!chat.delete && chat.unreadCount > 0) {
          // 找到第一个未读会话，激活它
          const originalIndex = chat.originalIndex;
          console.log('[Chat] 找到未读会话:', chat.showName, '未读数:', chat.unreadCount);
          this.onActiveItem(originalIndex);
          return;
        }
      }

      // 如果没有未读会话，不做任何处理
      console.log('[Chat] 没有未读会话');
    },
    // 获取初始侧边栏宽度
    getInitialSidebarWidth() {
      // 尝试从 localStorage 读取保存的宽度
      const savedWidth = localStorage.getItem('chatSidebarWidth');
      if (savedWidth) {
        return parseInt(savedWidth, 10);
      }
      // 默认宽度 260px
      return 260;
    },

    // 分隔条鼠标按下事件
    handleResizerMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartWidth = this.sidebarWidth;

      // 添加全局鼠标事件监听
      document.addEventListener('mousemove', this.handleResizerMouseMove);
      document.addEventListener('mouseup', this.handleResizerMouseUp);

      // 设置拖拽时的样式
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },

    // 分隔条鼠标移动事件
    handleResizerMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      const deltaX = e.clientX - this.dragStartX;
      const newWidth = this.dragStartWidth + deltaX;

      // 设置最小宽度和最大宽度
      const minWidth = 200;
      const maxWidth = window.innerWidth * 0.8;

      // 限制宽度范围
      const clampedWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));

      // 保存待更新的宽度，等待 requestAnimationFrame 批量更新
      this.pendingWidth = clampedWidth;

      // 如果没有正在进行的动画帧，请求一个新的
      if (!this.animationFrameId) {
        this.animationFrameId = requestAnimationFrame(this.updateSidebarWidth);
      }
    },

    // 使用 requestAnimationFrame 批量更新侧边栏宽度
    updateSidebarWidth() {
      if (this.pendingWidth !== null) {
        this.sidebarWidth = this.pendingWidth;
        this.pendingWidth = null;
      }
      this.animationFrameId = null;
    },

    // 分隔条鼠标释放事件
    handleResizerMouseUp() {
      if (!this.isDragging) return;

      this.isDragging = false;

      // 取消任何挂起的动画帧
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }

      // 如果有待更新的宽度，立即更新
      if (this.pendingWidth !== null) {
        this.sidebarWidth = this.pendingWidth;
        this.pendingWidth = null;
      }

      // 移除全局事件监听
      document.removeEventListener('mousemove', this.handleResizerMouseMove);
      document.removeEventListener('mouseup', this.handleResizerMouseUp);

      // 恢复默认样式
      document.body.style.cursor = '';
      document.body.style.userSelect = '';

      // 保存宽度到 localStorage
      localStorage.setItem('chatSidebarWidth', this.sidebarWidth.toString());
    },

    // 分隔条鼠标离开事件
    onResizerMouseLeave() {
      if (!this.isDragging) {
        this.isResizerHovered = false;
      }
    },

    onActiveItem(index) {
      this.activeView = "chat";
      // 特殊处理：点击"智能体"聚合条目
      if (index === -1) {
        this.enterAgentListView(null, -1);
        return;
      }

      // 如果在智能体列表视图中,直接激活会话
      if (this.viewMode === 'agent-list') {
        this.$store.commit("activeChat", index);
        this.detectPCTerminalChat();
        return;
      }

      // 检查是否点击的是虚拟聚合条目
      const chat = this.chatStore.chats[index];
      if (chat && chat.type === 'AGENT_AGGREGATE') {
        this.enterAgentListView(null, -1);
        return;
      }

      // 普通会话,直接激活
      this.$store.commit("activeChat", index);
      this.detectPCTerminalChat();
    },
    
    // 检测是否为PC终端会话
    detectPCTerminalChat() {
      if (!this.chatStore.activeChat) {
        this.isPCTerminalChat = false;
        this.isOpenClawTerminalChat = false;
        this.isCloudOpenClawChat = false;
        return;
      }

      // 🔥 智能体会话不显示云电脑管理面板
      const isAgentChat = this.chatStore.activeChat.type === 'AGENT' ||
                         (this.chatStore.activeChat.targetId && String(this.chatStore.activeChat.targetId).includes('agent_'));

      if (isAgentChat) {
        this.isPCTerminalChat = false;
        this.isOpenClawTerminalChat = false;
        this.isCloudOpenClawChat = false;
        return;
      }

      const targetId = this.chatStore.activeChat.targetId;
      this.isPCTerminalChat = targetId ? String(targetId).includes('_3') : false;
      this.isOpenClawTerminalChat = targetId ? String(targetId).includes('_6') : false;
      this.isCloudOpenClawChat = targetId ? String(targetId).includes('_7') : false;
    },

    // 确保小龙虾端和云小龙虾端会话存在于侧边栏
    ensureTerminalChats() {
      const userId = this.$store.state.userStore.userInfo?.id;
      if (!userId) return;
      const terminals = [
        { type: 6, name: '我的小龙虾端', icon: '🦞' },
        { type: 7, name: '我的云小龙虾端', icon: '☁️🦞' }
      ];
      terminals.forEach(t => {
        const targetId = `${userId}_${t.type}`;
        const exists = this.chatStore.chats.some(c => c.targetId === targetId && !c.delete);
        if (!exists) {
          this.$store.commit('openChat', {
            type: 'PRIVATE',
            targetId,
            senderTerminal: t.type,
            showName: t.name,
            headImage: t.icon,
            isTerminalChat: true
          });
        }
      });
    },

    // 数字员工面板中点击了某个 agent 发起会话
    onAgentChatOpened(chatInfo) {
      this.isOpenClawTerminalChat = false;
      this.isCloudOpenClawChat = false;
    },

    // 处理文件发送到IM会话
    handleSendFiles(payload) {
      const { files, session } = payload;

      console.log('[Chat] 处理文件发送:', {
        filesCount: files.length,
        sessionName: session.name,
        sessionType: session.type
      });

      // 获取当前文件发送模式
      const fileSendMode = this.$store.getters.fileSendMode;
      console.log('[Chat] 文件发送模式:', fileSendMode);

      if (fileSendMode === 'direct') {
        // 直接发送模式：调用 ChatBox 的文件发送方法
        this.sendFilesDirect(files, session);
      } else {
        // agent 模式：当前实现（通过 Happy iframe）
        this.sendFilesToAgent(files, session);
      }
    },

    // agent 模式：通过 Happy iframe 发送文件
    sendFilesToAgent(files, session) {
      console.log('[Chat] agent 模式 - 通过智能体发送');

      // 获取 HappyIframeBridge 实例
      const iframeBridge = window.__imHappyIframeBridge;

      if (!iframeBridge) {
        console.error('[Chat] HappyIframeBridge 未初始化');
        this.$message.error('Happy iframe 未初始化，无法发送文件');
        return;
      }

      // 检查是否就绪
      if (!iframeBridge.getIsReady()) {
        console.warn('[Chat] HappyIframeBridge 未就绪');
        this.$message.warning('Happy iframe 未就绪，请稍后再试');
        return;
      }

      // 发送文件到 Happy
      try {
        iframeBridge.sendFilesToImSession(files, session);

        // 显示成功提示
        const fileNames = files.map(f => f.name).join(', ');
        this.$message.success({
          message: `正在发送 ${files.length} 个文件到 ${session.name}`,
          duration: 2000
        });

      } catch (error) {
        console.error('[Chat] 发送文件失败:', error);
        this.$message.error('发送文件失败');
      }
    },

    // direct 模式：直接通过 API 发送文件
    async sendFilesDirect(files, session) {
      try {
        // 获取当前用户信息
        const userInfo = this.$store.state.userStore.userInfo;
        if (!userInfo || !userInfo.id) {
          this.$message.error('无法获取用户信息');
          return;
        }

        const podName = `vnc-${userInfo.id}`;
        const messageAction = `/message/${session.type.toLowerCase()}/send`;

        // 从 sessionStorage 获取 Token-Key
        const userTokenKey = sessionStorage.getItem('tokenKey');
        if (!userTokenKey) {
          this.$message.error('无法获取用户认证信息');
          return;
        }

        // 并行上传所有文件
        const uploadPromises = files.map(async (file) => {
          try {
            // 判断是VNC文件路径还是浏览器File对象
            const isVncFile = file.path && typeof file.path === 'string';
            const fileName = file.name || (file.path ? file.path.split('/').pop() : 'unknown');

            let uploadResult;
            let isImage;

            if (isVncFile) {
              // VNC文件：通过vnc-pod-manager代理上传
              const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
              const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
              isImage = imageExts.includes(ext);

              const vncApi = require('@/api/vncApi.js');
              if (isImage) {
                uploadResult = await vncApi.uploadImageToIM(podName, file.path);
              } else {
                uploadResult = await vncApi.uploadFileToIM(podName, file.path);
              }

              if (!uploadResult || uploadResult.code !== 200) {
                throw new Error(uploadResult?.message || '上传失败');
              }

              uploadResult = uploadResult.data;

            } else {
              // 浏览器File对象：传统上传方式
              isImage = file.type && file.type.startsWith('image/');
              const uploadUrl = isImage ? '/image/upload' : '/file/upload';

              const formData = new FormData();
              formData.append('file', file);

              uploadResult = await this.$http.post(uploadUrl, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });
            }

            // 构造消息体
            const msgInfo = {
              sendId: userInfo.id,
              sendTime: new Date().getTime(),
              type: isImage ? 1 : 2, // 1=图片, 2=文件
              status: 0
            };

            // 填充目标ID
            if (session.type === 'GROUP') {
              msgInfo.groupId = session.targetId;
            } else if (session.type === 'PRIVATE') {
              msgInfo.recvId = session.targetId;
            }

            // 填充内容
            if (isImage) {
              msgInfo.content = JSON.stringify(uploadResult);
            } else {
              msgInfo.content = JSON.stringify({
                name: fileName,
                size: file.size || 0,
                url: uploadResult
              });
            }

            // 使用原生 axios 发送，只携带 Token-Key (terminal=5)
            const axios = require('axios').default || require('axios');
            const baseURL = process.env.VUE_APP_BASE_API || 'http://127.0.0.1:8888';
            await axios({
              url: `${baseURL}${messageAction}`,
              method: 'post',
              data: msgInfo,
              headers: {
                'Content-Type': 'application/json',
                'Token-Key': userTokenKey
              },
              withCredentials: true,
              timeout: 30000
            });

            return { success: true, file: fileName };

          } catch (error) {
            console.error('[Chat] 文件发送失败:', file.name || file.path, error);
            return { success: false, file: file.name || file.path };
          }
        });

        // 等待所有文件上传完成
        const results = await Promise.all(uploadPromises);

        // 统计成功和失败数量
        const failedFiles = results.filter(r => !r.success);
        const successCount = results.filter(r => r.success).length;

        if (successCount > 0) {
          this.$message.success(`成功发送 ${successCount} 个文件到 ${session.name}`);
        }
        if (failedFiles.length > 0) {
          const failedNames = failedFiles.map(r => r.file).join(', ');
          this.$message.error(`${failedFiles.length} 个文件发送失败: ${failedNames}`);
        }

      } catch (error) {
        console.error('[Chat] 直接发送文件失败:', error);
        this.$message.error('文件发送失败: ' + error.message);
      }
    },

    // 🔥 遮罩层 mousemove 处理器（现在绑定到document.body）
    handleOverlayMouseMove(e) {
      if (!this.draggedFiles) {
        console.log('⚠️ mousemove 但 draggedFiles 为空，跳过');
        return;
      }

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      // 🔥 参考demo：每5次输出一次日志（减少日志频率）
      if (!this._moveCount) this._moveCount = 0;
      this._moveCount++;

      if (this._moveCount % 5 === 0) {
        console.log('🟡 遮罩层捕获鼠标移动:', mouseX, mouseY);
      }

      // 更新拖拽指示器位置（按照demo，不使用offset）
      const dragPreview = document.getElementById('im-drag-preview');
      if (dragPreview) {
        dragPreview.style.left = `${mouseX}px`;
        dragPreview.style.top = `${mouseY}px`;
      }

      // 🔥 精准检测：临时隐藏遮罩层（完全按照demo第277-279行）
      const overlay = document.querySelector('.drag-capture-overlay');
      if (overlay) overlay.style.display = 'none';
      const elementBelow = document.elementFromPoint(mouseX, mouseY);
      if (overlay) overlay.style.display = 'block';

      // 清除之前的高亮
      if (this.currentHighlightedChatIndex !== null) {
        this.$eventBus.$emit('workspace-drag-clear');
        this.$root.$emit('workspace-drag-clear');
        this.currentHighlightedChatIndex = null;
      }

      // 查找最近的 ChatItem
      const chatItem = elementBelow?.closest('.chat-item');

      if (chatItem) {
        const chatIndex = chatItem.getAttribute('data-chat-index');

        if (chatIndex && chatIndex !== 'null' && chatIndex !== '-1') {
          this.currentHighlightedChatIndex = chatIndex;
          this.$eventBus.$emit('workspace-drag-over', chatIndex);
          this.$root.$emit('workspace-drag-over', chatIndex);

          if (this._moveCount % 5 === 0) {
            const chat = this.sortedChats.find(c => c.originalIndex?.toString() === chatIndex);
            console.log('🎯 悬停在:', chatIndex, '-', chat?.showName || 'unknown');
          }
        }
      }
    },

    // 🔥 mouseup 处理器（现在绑定到document.body）
    handleOverlayMouseUp(e) {
      if (!this.draggedFiles) {
        console.log('⚠️ mouseup 但 draggedFiles 为空，跳过');
        return;
      }

      console.log('🎯 遮罩层捕获释放:', e.clientX, e.clientY);

      // 🔥 立即移除 overlay 的 active class（阻止后续 mousemove 事件）
      const overlay = document.querySelector('.drag-capture-overlay');
      if (overlay) {
        overlay.classList.remove('active');
        console.log('✅ overlay active class 已移除');
      }

      // 重置移动计数器
      this._moveCount = 0;

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      // 🔥 精准检测：临时隐藏遮罩层（完全按照demo）
      if (overlay) overlay.style.display = 'none';
      const elementBelow = document.elementFromPoint(mouseX, mouseY);
      if (overlay) overlay.style.display = 'block';

      console.log('📍 释放位置的元素:', elementBelow);

      // 🔥 查找最近的 ChatItem
      const chatItem = elementBelow?.closest('.chat-item');
      if (chatItem) {
        const chatIndex = chatItem.getAttribute('data-chat-index');
        console.log('🔍 找到 ChatItem, index:', chatIndex);

        if (chatIndex && chatIndex !== 'null' && chatIndex !== '-1') {
          const chat = this.sortedChats.find(c => c.originalIndex?.toString() === chatIndex);
          console.log('✅ 拖拽成功！释放在:', chatIndex, '-', chat?.showName || 'unknown');

          // 🔥 构造会话对象
          if (chat && this.draggedFiles.files) {
            const session = {
              id: chat.id || chat.originalIndex,
              targetId: chat.targetId,
              type: chat.type,
              name: chat.showName
            };

            console.log('🎯 构造会话对象:', session);
            console.log('📁 拖拽的文件:', this.draggedFiles.files);

            // 调用发送文件处理逻辑
            this.handleSendFiles({
              files: this.draggedFiles.files,
              session: session
            });

            // 向子iframe发送成功反馈（仅在 agent 模式）
            const fileSendMode = this.$store.getters.fileSendMode;
            if (fileSendMode === 'agent') {
              const happyIframe = document.querySelector('.agent-iframe');
              if (happyIframe && happyIframe.contentWindow) {
                happyIframe.contentWindow.postMessage({
                  type: 'DROP_SUCCESS',
                  msg: `已放置到: ${chat.showName}`,
                  chatIndex: chatIndex,
                  sessionInfo: {
                    sessionType: session.type,
                    targetId: session.targetId,
                    sessionName: session.name
                  }
                }, '*');
              }
            }
          }
        }
      } else {
        console.log('⚠️ 释放在放置区外');
      }

      // 🔥 清理拖拽状态（按照demo的mouseup处理）
      console.log('🧹 开始清理拖拽状态...');

      this.draggedFiles = null;
      window.__draggedWorkspaceFiles = null;
      this.currentHighlightedChatIndex = null;

      // 移除拖拽指示器
      const dragPreview = document.getElementById('im-drag-preview');
      if (dragPreview) {
        dragPreview.remove();
        console.log('✅ 拖拽指示器已移除');
      }

      // 🔑 禁用遮罩层（参考demo第251行）
      const overlay2 = document.querySelector('.drag-capture-overlay');
      if (overlay2) {
        overlay2.classList.remove('active');
        console.log('✅ 遮罩层已禁用');
      }

      // 清除所有 ChatItem 的 hover 状态
      this.$eventBus.$emit('workspace-drag-clear');
      this.$root.$emit('workspace-drag-clear');

      // 🔥 向子iframe发送拖拽完成通知（按照demo）
      const happyIframe = document.querySelector('.agent-iframe');
      if (happyIframe && happyIframe.contentWindow) {
        happyIframe.contentWindow.postMessage({
          type: 'DRAG_COMPLETE'
        }, '*');
        console.log('✅ DRAG_COMPLETE 已发送给子iframe');
      }

      console.log('✅ 拖拽状态清理完成');
    },

    // 处理来自 Happy iframe 的 postMessage
    handlePostMessage(event) {
      // console.log('[Chat] ========== 收到 postMessage ==========');
      // console.log('[Chat] event.origin:', event.origin);
      // console.log('[Chat] event.data:', event.data);
      // console.log('[Chat] event.source:', event.source);

      // 验证消息来源（可以添加 origin 检查）
      const message = event.data;

      if (!message || typeof message !== 'object') {
        console.log('[Chat] 消息无效，跳过处理');
        return;
      }

      // 处理拖拽开始
      if (message.type === 'WORKSPACE_FILE_DRAG_START') {
        console.log('[Chat] 🟢 拖拽开始 -', message.data?.files?.length, '个文件');

        this.draggedFiles = message.data;
        window.__draggedWorkspaceFiles = message.data;

        // 🔑 关键：不立即激活遮罩层，等待DRAG_MOVE判断鼠标是否移出iframe
        // 因为遮罩层的 pointer-events: auto 会阻挡 HTML5 drag 事件
        console.log('[Chat] ✅ 拖拽开始，等待鼠标移出iframe才激活遮罩层');

        // 🔥 在父窗口创建拖拽指示器（简约风格，与 WorkspaceFileTree 一致）
        const dragPreview = document.createElement('div');
        dragPreview.id = 'im-drag-preview';
        dragPreview.style.cssText = `
          position: fixed;
          left: -9999px;
          top: -9999px;
          pointer-events: none;
          z-index: 100000;
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          padding: 8px 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          backdrop-filter: blur(10px);
          transform: translate(-50%, -50%);
        `;

        // 文件图标
        const icon = document.createElement('span');
        icon.style.cssText = 'font-size: 16px;';
        icon.textContent = message.data.files[0].isDir ? '📁' : '📄';

        // 文件名或数量
        const label = document.createElement('span');
        label.style.cssText = 'color: #333; font-weight: 500;';
        const fileCount = message.data.files.length;
        if (fileCount === 1) {
          label.textContent = message.data.files[0].name;
        } else {
          label.textContent = `${fileCount} items`;
        }

        dragPreview.appendChild(icon);
        dragPreview.appendChild(label);

        // 如果多个文件，添加数量徽章
        if (fileCount > 1) {
          const badge = document.createElement('span');
          badge.style.cssText = `
            background: #007AFF;
            color: white;
            border-radius: 10px;
            padding: 2px 6px;
            font-size: 11px;
            font-weight: 600;
            margin-left: 4px;
          `;
          badge.textContent = fileCount.toString();
          dragPreview.appendChild(badge);
        }

        document.body.appendChild(dragPreview);
        console.log('[Chat] ✅ 拖拽指示器已创建:', fileCount === 1 ? message.data.files[0].name : `${fileCount} items`);
      }

      // 🔥 处理 DRAG_MOVE 消息（iframe内的鼠标移动）
      if (message.type === 'WORKSPACE_FILE_DRAG_MOVE') {
        if (!this.draggedFiles) {
          return;
        }

        // 🔥 获取iframe的位置
        const happyIframe = document.querySelector('.agent-iframe');
        if (!happyIframe) return;

        const iframeRect = happyIframe.getBoundingClientRect();

        // 🔥 将iframe内部坐标转换为父窗口坐标
        const parentX = iframeRect.left + message.x;
        const parentY = iframeRect.top + message.y;

        // 🔥 判断鼠标是否在iframe内（参考demo第270-274行）
        const isInsideIframe =
          message.x >= 0 && message.x <= iframeRect.width &&
          message.y >= 0 && message.y <= iframeRect.height;

        const dragPreview = document.getElementById('im-drag-preview');
        const overlay = document.querySelector('.drag-capture-overlay');

        if (isInsideIframe) {
          // 🔑 关键：在iframe内时，禁用遮罩层（让iframe接收HTML5 drag事件）
          if (overlay && overlay.classList.contains('active')) {
            overlay.classList.remove('active');
            console.log('[Chat] 🔵 鼠标在iframe内，禁用遮罩层');
          }
          // 隐藏拖拽指示器
          if (dragPreview) {
            dragPreview.style.display = 'none';
          }
          // 清除父窗口的高亮
          if (this.currentHighlightedChatIndex !== null) {
            this.$eventBus.$emit('workspace-drag-clear');
            this.$root.$emit('workspace-drag-clear');
            this.currentHighlightedChatIndex = null;
          }
          return; // 🔑 直接返回，不处理
        } else {
          // 🔑 鼠标移出iframe，激活遮罩层（拦截事件给父窗口处理）
          if (overlay && !overlay.classList.contains('active')) {
            overlay.classList.add('active');
            console.log('[Chat] 🟡 鼠标移出iframe，激活遮罩层');
          }
          // 显示拖拽指示器
          if (dragPreview) {
            dragPreview.style.display = 'block';
          }
        }

        // 🔑 只有在iframe外时才处理mousemove（检测ChatItem悬停）
        this.handleOverlayMouseMove({
          clientX: parentX,
          clientY: parentY
        });

        return;
      }

      // 处理拖拽结束（执行 drop 检测）
      if (message.type === 'WORKSPACE_FILE_DRAG_END') {
        console.log('[Chat] ========== 拖拽结束（DRAG_END消息） ==========');
        console.log('[Chat] 🎯 iframe 内 mouseup 坐标:', message.x, message.y);

        if (!this.draggedFiles) {
          console.log('[Chat] ⚠️ draggedFiles 为空，跳过');
          return;
        }

        // 🔑 关键：判断鼠标是否在 iframe 内释放（参考demo）
        const happyIframe = document.querySelector('.agent-iframe');
        if (happyIframe) {
          const iframeRect = happyIframe.getBoundingClientRect();

          // 检查坐标是否在 iframe 范围内
          const isInsideIframe =
            message.x >= 0 && message.x <= iframeRect.width &&
            message.y >= 0 && message.y <= iframeRect.height;

          if (isInsideIframe) {
            console.log('[Chat] 🔵 在 iframe 内释放，由 iframe 自己处理（AgentInput）');

            // 🔑 只清理状态，不做任何检测（让 iframe 内部的 drop 事件处理）
            this.draggedFiles = null;
            window.__draggedWorkspaceFiles = null;
            this.currentHighlightedChatIndex = null;
            this._moveCount = 0;

            // 移除拖拽指示器
            const dragPreview = document.getElementById('im-drag-preview');
            if (dragPreview) {
              dragPreview.remove();
            }

            // 禁用遮罩层
            const overlay = document.querySelector('.drag-capture-overlay');
            if (overlay) {
              overlay.classList.remove('active');
            }

            // 清除所有 ChatItem 的 hover 状态
            this.$eventBus.$emit('workspace-drag-clear');
            this.$root.$emit('workspace-drag-clear');

            // 向子iframe发送拖拽完成通知
            if (happyIframe.contentWindow) {
              happyIframe.contentWindow.postMessage({
                type: 'DRAG_COMPLETE'
              }, '*');
            }

            console.log('[Chat] ✅ iframe 内释放，状态清理完成');
            return; // 🔑 直接返回，不执行后续的 ChatItem 检测逻辑
          }
        }

        // 🔑 如果执行到这里，说明是在 iframe 外释放，需要检测 ChatItem
        console.log('[Chat] 🟡 在 iframe 外释放，检测 ChatItem');

        // 立即移除 overlay 的 active class
        const overlay = document.querySelector('.drag-capture-overlay');
        if (overlay) {
          overlay.classList.remove('active');
        }

        // 将 iframe 内坐标转换为父窗口坐标
        if (happyIframe) {
          const iframeRect = happyIframe.getBoundingClientRect();
          const parentX = iframeRect.left + message.x;
          const parentY = iframeRect.top + message.y;

          console.log('[Chat] 🔍 转换后父窗口坐标:', parentX, parentY);

          // 精准检测：临时隐藏遮罩层
          if (overlay) overlay.style.display = 'none';
          const elementBelow = document.elementFromPoint(parentX, parentY);
          if (overlay) overlay.style.display = 'block';

          console.log('📍 释放位置的元素:', elementBelow);

          // 查找最近的 ChatItem
          const chatItem = elementBelow?.closest('.chat-item');
          if (chatItem) {
            const chatIndex = chatItem.getAttribute('data-chat-index');
            console.log('🔍 找到 ChatItem, index:', chatIndex);

            if (chatIndex && chatIndex !== 'null' && chatIndex !== '-1') {
              // 🔥 检测是否是智能体二级列表的 Item
              const isAgentItem = chatItem.classList.contains('agent-chat-item');
              console.log('🔍 是否是智能体Item:', isAgentItem);

              let targetChat = null;
              if (isAgentItem) {
                // 智能体Item：需要找到父级会话
                if (this.selectedParentChat) {
                  // 如果有保存的父级会话，直接使用
                  targetChat = this.selectedParentChat;
                  console.log('✅ 使用保存的父级会话:', targetChat?.showName);
                } else {
                  // 🔥 从智能体会话的 targetId 中解析父级会话
                  // targetId 格式: GROUP_123_agent_agent_xxx
                  const agentChat = this.chatStore.chats[parseInt(chatIndex)];
                  if (agentChat && agentChat.targetId && agentChat.targetId.includes('_agent_')) {
                    const parts = agentChat.targetId.split('_agent_');
                    const parentInfo = parts[0]; // 例如: "GROUP_123"
                    const [parentType, parentTargetId] = parentInfo.split('_');

                    console.log('🔍 解析父级会话信息:', { parentType, parentTargetId });

                    // 从 chats 中找到父级会话
                    targetChat = this.chatStore.chats.find(c =>
                      c.type === parentType && c.targetId?.toString() === parentTargetId
                    );
                    console.log('✅ 从 targetId 解析父级会话:', targetChat?.showName);
                  }
                }
              } else {
                // 普通Item：从 sortedChats 查找
                targetChat = this.sortedChats.find(c => c.originalIndex?.toString() === chatIndex);
                console.log('✅ 拖拽到普通Item，从 sortedChats 查找:', targetChat?.showName);
              }

              console.log('🔍 调试: targetChat:', targetChat);
              console.log('🔍 调试: this.draggedFiles:', this.draggedFiles);
              console.log('🔍 调试: this.draggedFiles.files:', this.draggedFiles?.files);

              // 🔥 构造会话对象
              if (targetChat && this.draggedFiles.files) {
                const session = {
                  id: targetChat.id || targetChat.originalIndex,
                  targetId: targetChat.targetId,
                  type: targetChat.type,
                  name: targetChat.showName
                };

                console.log('🎯 构造会话对象:', session);
                console.log('📁 拖拽的文件:', this.draggedFiles.files);

                // 调用发送文件处理逻辑
                this.handleSendFiles({
                  files: this.draggedFiles.files,
                  session: session
                });

                // 向子iframe发送成功反馈（仅在 agent 模式）
                const fileSendMode = this.$store.getters.fileSendMode;
                if (fileSendMode === 'agent' && happyIframe.contentWindow) {
                  happyIframe.contentWindow.postMessage({
                    type: 'DROP_SUCCESS',
                    msg: `已放置到: ${targetChat.showName}`,
                    chatIndex: chatIndex,
                    sessionInfo: {
                      sessionType: session.type,
                      targetId: session.targetId,
                      sessionName: session.name
                    }
                  }, '*');
                }
              }
            }
          } else {
            console.log('⚠️ 释放在放置区外');
          }
        }

        // 🔥 清理拖拽状态
        console.log('🧹 开始清理拖拽状态...');

        this.draggedFiles = null;
        window.__draggedWorkspaceFiles = null;
        this.currentHighlightedChatIndex = null;
        this._moveCount = 0;

        // 移除拖拽指示器
        const dragPreview = document.getElementById('im-drag-preview');
        if (dragPreview) {
          dragPreview.remove();
          console.log('✅ 拖拽指示器已移除');
        }

        // 🔑 禁用遮罩层（参考demo第251行）
        const overlay3 = document.querySelector('.drag-capture-overlay');
        if (overlay3) {
          overlay3.classList.remove('active');
          console.log('✅ 遮罩层已禁用');
        }

        // 清除所有 ChatItem 的 hover 状态
        this.$eventBus.$emit('workspace-drag-clear');
        this.$root.$emit('workspace-drag-clear');

        // 🔥 向子iframe发送拖拽完成通知
        if (happyIframe && happyIframe.contentWindow) {
          happyIframe.contentWindow.postMessage({
            type: 'DRAG_COMPLETE'
          }, '*');
          console.log('✅ DRAG_COMPLETE 已发送给子iframe');
        }

        console.log('✅ 拖拽状态清理完成');
      }
    },

    onDelItem(chat) {
      console.log('[Chat] 删除会话:', chat);
      if (!chat) {
        console.error('[Chat] 删除失败：会话对象无效');
        this.$message.error('删除失败：会话对象无效');
        return;
      }
      // 通过会话对象查找真实索引
      const realIndex = this.chatStore.chats.findIndex(c =>
        c.type === chat.type && c.targetId === chat.targetId
      );
      if (realIndex === -1) {
        console.error('[Chat] 删除失败：未找到会话');
        this.$message.error('删除失败：未找到会话');
        return;
      }
      console.log('[Chat] 找到真实索引:', realIndex);
      this.$store.commit("removeChat", realIndex);
      console.log('[Chat] 删除完成');
    },
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
    
    // 获取当前终端类型
    getCurrentTerminal() {
      // 根据环境判断当前终端类型
      if (typeof window !== 'undefined') {
        // 检测VSCode环境
        if (window.parent !== window || 
          window.acquireVsCodeApi || 
          window.isVSCodeEnvironment || 
          (window.location && window.location.protocol === 'vscode-webview:')) {
          return 2; // VSCode
        }
        // 检测PC客户端环境
        if (window.isElectronApp || window.electronAPI) {
          return 3; // PC
        }
        // 检测插件环境
        if (window.chrome && window.chrome.runtime && window.chrome.runtime.id) {
          return 4; // 插件
        }
        return 0; // Web
      }
      // 移动端环境
      if (typeof uni !== 'undefined') {
        return 1; // App
      }
      return 0; // 默认Web
    },
    
    // 生成会话显示Key（用于Vue的key属性）
    generateChatKey(chat, index) {
      if (chat.type === 'AGENT_AGGREGATE') {
        return 'agent-aggregate';
      }
      if (chat.isTerminalChat) {
        return `terminal-chat-${chat.senderTerminal}-${chat.targetId}`;
      } else if (chat.isTerminalInbox) {
        return `terminal-inbox-${chat.receivingTerminal}-${chat.targetId}`;
      } else {
        return `${chat.type}-${chat.targetId}-${index}`;
      }
    },
    
    // 消息发送处理
    onMessageSent(message) {
      console.log('消息已发送:', message);

      // 如果容器管理面板存在且未折叠，则自动折叠
      if (this.$refs.containerManager && !this.$refs.containerManager.isCollapsed) {
        console.log('[Chat] 发送消息，自动折叠容器管理面板');
        this.$refs.containerManager.toggleCollapse();
      }
    },

    // ===== 智能体两级列表相关方法 =====

    // 判断会话项是否激活
    isActiveChatItem(chat) {
      // 智能体聚合条目：在智能体列表视图时显示激活状态
      if (chat.type === 'AGENT_AGGREGATE') {
        return this.viewMode === 'agent-list';
      }

      // 普通会话：当它是当前激活会话时显示激活状态
      return this.chatStore.activeChat &&
             chat.type === this.chatStore.activeChat.type &&
             chat.targetId === this.chatStore.activeChat.targetId;
    },

    // 获取智能体会话列表（如果没有指定父会话，返回所有智能体会话）
    getFilteredAgents(parentChat) {
      // 获取所有智能体会话
      const allAgentChats = this.chatStore.chats.filter(chat => chat.type === 'AGENT');

      // 添加原始索引
      const chatsWithIndex = allAgentChats.map((chat, idx) => {
        const originalIndex = this.chatStore.chats.findIndex(c =>
          c.type === chat.type && c.targetId === chat.targetId
        );
        return {
          ...chat,
          originalIndex: originalIndex
        };
      }).filter(chat =>
        chat.showName && chat.showName.includes(this.searchText)
      );

      // 🔥 按最后消息时间倒序排列，确保最新会话在顶部
      chatsWithIndex.sort((a, b) => {
        const aTime = a.lastSendTime || 0;
        const bTime = b.lastSendTime || 0;
        return bTime - aTime;
      });

      return chatsWithIndex;
    },

    // 进入智能体列表视图
    enterAgentListView(parentChat, parentIndex) {
      if (this.agentListAnimating) return; // 防止动画期间重复点击

      // 保存主列表滚动位置
      const mainScrollbar = this.$refs.mainListScrollbar;
      if (mainScrollbar && mainScrollbar.$refs.wrap) {
        this.mainListScrollTop = mainScrollbar.$refs.wrap.scrollTop;
      }

      // parentChat 为 null 表示查看所有智能体
      this.selectedParentChat = parentChat;
      this.selectedParentIndex = parentIndex;
      this.agentListAnimating = true;
      this.viewMode = 'agent-list';

      // 🔥 从服务端刷新智能体会话列表，确保获取最新数据
      this.$store.dispatch('loadAgentChatsFromServer').catch(error => {
        console.error('[Chat] 刷新智能体会话列表失败:', error);
      });

      // 动画完成后清除标识
      setTimeout(() => {
        this.agentListAnimating = false;
        // 恢复智能体列表滚动位置
        this.$nextTick(() => {
          const agentScrollbar = this.$refs.agentListScrollbar;
          if (agentScrollbar && agentScrollbar.$refs.wrap) {
            agentScrollbar.$refs.wrap.scrollTop = this.agentListScrollTop;
          }
        });
      }, 400); // 动画时长
    },

    // 返回主列表视图
    backToMainView() {
      if (this.agentListAnimating) return; // 防止动画期间重复点击

      // 保存智能体列表滚动位置
      const agentScrollbar = this.$refs.agentListScrollbar;
      if (agentScrollbar && agentScrollbar.$refs.wrap) {
        this.agentListScrollTop = agentScrollbar.$refs.wrap.scrollTop;
      }

      this.agentListAnimating = true;
      this.viewMode = 'main';

      // 动画完成后清除标识和选中状态
      setTimeout(() => {
        this.agentListAnimating = false;
        this.selectedParentChat = null;
        this.selectedParentIndex = null;
        // 恢复主列表滚动位置
        this.$nextTick(() => {
          const mainScrollbar = this.$refs.mainListScrollbar;
          if (mainScrollbar && mainScrollbar.$refs.wrap) {
            mainScrollbar.$refs.wrap.scrollTop = this.mainListScrollTop;
          }
        });
      }, 400); // 动画时长
    },

    // 打开智能体侧边栏(用于空状态引导)
    openAgentSidebar() {
      // 点击"浏览智能体广场"按钮，跳转到 /home/index
      this.$router.push('/home/index');
    },

    // 处理显示智能体列表事件
    handleShowAgentList() {
      this.enterAgentListView(null, -1);
      // 激活最新的智能体会话（按更新时间排序）
      this.$nextTick(() => {
        const agentChats = this.chatStore.chats
          .map((c, idx) => ({ ...c, originalIndex: idx }))
          .filter(c => c.type === 'AGENT')
          .sort((a, b) => (b.lastSendTime || 0) - (a.lastSendTime || 0));
        if (agentChats.length > 0) {
          this.$store.commit('activeChat', agentChats[0].originalIndex);
        }
      });
    },

    // 键盘事件处理
    handleKeyDown(event) {
      // ESC 键返回主列表
      if (event.key === 'Escape' && this.viewMode === 'agent-list') {
        this.backToMainView();
      }
    },

    // 🎯 处理智能体分享链接 - 从URL参数初始化智能体会话
    async handleAgentShareLink() {
      console.log('[agent share debug] ========== Chat: handleAgentShareLink 被调用 ==========');
      console.log('[agent share debug] [Chat] $route.query:', this.$route.query);

      const agentId = this.$route.query.agentId;
      const autoStart = this.$route.query.autoStart;

      if (!agentId || autoStart !== 'true') {
        console.log('[agent share debug] [Chat] ⚠️ 没有 agentId 或 autoStart 参数，跳过智能体初始化');
        return;
      }

      // 🔥 防重复调用检查
      if (this.isHandlingAgentInit) {
        console.log('[agent share debug] [Chat] ⚠️ 智能体初始化正在进行中，跳过重复调用');
        return;
      }

      if (this.lastHandledAgentId === agentId) {
        console.log('[agent share debug] [Chat] ⚠️ 该智能体已处理过，跳过重复初始化:', agentId);
        return;
      }

      // 🔥 设置处理中标志
      this.isHandlingAgentInit = true;
      this.lastHandledAgentId = agentId;
      console.log('[agent share debug] [Chat] 🔒 已设置防重复调用标志');

      try {
        // 1. 等待用户信息加载
        console.log('[agent share debug] [Chat] Step 1: 检查用户信息');
        if (!this.$store.state.userStore.userInfo?.id) {
          console.warn('[agent share debug] [Chat] ⚠️ 用户信息未加载，等待加载...');
          let retries = 10;
          while (retries > 0 && !this.$store.state.userStore.userInfo?.id) {
            await new Promise(resolve => setTimeout(resolve, 500));
            retries--;
          }

          if (!this.$store.state.userStore.userInfo?.id) {
            console.error('[agent share debug] [Chat] ❌ 用户信息加载超时');
            this.$message.error('用户信息加载超时');
            return;
          }
        }
        console.log('[agent share debug] [Chat] ✅ 用户信息已加载');

        // 2. 先主动触发智能体会话列表加载
        console.log('[agent share debug] [Chat] Step 2: 主动触发智能体会话列表加载');
        this.$store.dispatch('loadAgentChatsFromServer').catch(error => {
          console.error('[agent share debug] [Chat] ⚠️ 触发加载失败，继续等待:', error);
        });

        // 等待智能体会话列表加载完成
        console.log('[agent share debug] [Chat] Step 2.1: 等待智能体会话列表加载');
        let retries = 20; // 最多等待10秒
        let agentChat = null;

        while (retries > 0) {
          agentChat = this.chatStore.chats.find(c =>
            c.type === 'AGENT' && c.agentId === agentId
          );

          if (agentChat) {
            console.log('[agent share debug] [Chat] ✅ 找到智能体会话:', agentChat);
            break;
          }

          await new Promise(resolve => setTimeout(resolve, 500));
          retries--;
        }

        if (!agentChat) {
          console.error('[agent share debug] [Chat] ❌ 未找到智能体会话，超时');
          this.$message.error('未找到智能体会话');
          return;
        }

        // 🔥 2.5. 如果 showName 包含"未知会话"，等待父会话加载并重新刷新
        if (agentChat.showName && agentChat.showName.includes('未知会话')) {
          console.log('[agent share debug] [Chat] ⚠️ 检测到未知会话，等待父会话加载...');

          // 等待父会话加载（最多等待5秒）
          let parentRetries = 10;
          let parentFound = false;

          while (parentRetries > 0) {
            const parentChat = this.chatStore.chats.find(c =>
              c.type === agentChat.parentType &&
              String(c.targetId) === String(agentChat.parentId)
            );

            if (parentChat && parentChat.showName) {
              console.log('[agent share debug] [Chat] ✅ 找到父会话:', parentChat.showName);
              parentFound = true;
              break;
            }

            await new Promise(resolve => setTimeout(resolve, 500));
            parentRetries--;
          }

          if (parentFound) {
            // 重新刷新智能体会话列表以更新 showName
            console.log('[agent share debug] [Chat] 🔄 重新刷新智能体会话列表...');
            await this.$store.dispatch('loadAgentChatsFromServer');

            // 重新获取智能体会话
            agentChat = this.chatStore.chats.find(c =>
              c.type === 'AGENT' && c.agentId === agentId
            );

            console.log('[agent share debug] [Chat] ✅ 更新后的 showName:', agentChat?.showName);
          } else {
            console.warn('[agent share debug] [Chat] ⚠️ 父会话加载超时，继续使用当前名称');
          }
        }

        // 3. 直接激活智能体会话
        console.log('[agent share debug] [Chat] Step 3: 激活智能体会话');
        console.log('[agent share debug] [Chat] - agentChat.targetId:', agentChat.targetId);
        console.log('[agent share debug] [Chat] - agentChat.showName:', agentChat.showName);

        const agentChatIndex = this.chatStore.chats.findIndex(c =>
          c.type === 'AGENT' && c.agentId === agentId
        );

        if (agentChatIndex === -1) {
          console.error('[agent share debug] [Chat] ❌ 无法找到智能体会话索引');
          this.$message.error('无法激活智能体会话');
          return;
        }

        console.log('[agent share debug] [Chat] ✅ 激活智能体会话, index:', agentChatIndex);
        this.$store.commit('activeChat', agentChatIndex);

        // 4. 等待 ChatBox 渲染，ChatBox 会自动处理 autoStart 参数
        await this.$nextTick();
        console.log('[agent share debug] [Chat] 🎯 智能体会话已激活，等待 ChatBox 处理 autoStart');

      } catch (error) {
        console.error('[agent share debug] [Chat] ❌ 智能体初始化失败:', error);
        this.$message.error(error.message || '智能体加载失败');
      } finally {
        this.isHandlingAgentInit = false;
        console.log('[agent share debug] [Chat] 🔓 已重置防重复调用标志');
      }
    }

  },
  computed: {
    chatStore() {
      return this.$store.state.chatStore;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg
    },
    // 是否为移动端全屏模式
    isMobileFullscreen() {
      return this.$route.query.fullscreen === 'true';
    },
    // 当前显示的智能体会话列表
    currentAgentChats() {
      return this.getFilteredAgents(this.selectedParentChat);
    },
    // 是否有智能体会话
    hasAgentChats() {
      return this.chatStore.chats.some(chat => chat.type === 'AGENT');
    },
    // 排序后的会话列表（终端会话置顶，过滤掉智能体会话，添加智能体聚合条目）
    sortedChats() {
      const chats = this.chatStore.chats || [];

      // 添加原始索引，用于保持操作的正确映射
      const chatsWithIndex = chats.map((chat, index) => ({
        ...chat,
        originalIndex: index
      }));

      // 分离终端会话和普通会话（过滤掉智能体会话）
      const terminalChats = [];
      const normalChats = [];
      let hasAgentChats = false;

      chatsWithIndex.forEach(chat => {
        // 过滤掉智能体会话 - 智能体会话只在二级列表中显示
        if (chat.type === 'AGENT') {
          hasAgentChats = true;
          return;
        }

        if (chat.isTerminalChat || chat.isTerminalInbox) {
          terminalChats.push(chat);
        } else {
          normalChats.push(chat);
        }
      });

      // 终端会话按终端类型排序
      terminalChats.sort((a, b) => {
        const aTerminal = a.senderTerminal || a.receivingTerminal || 0;
        const bTerminal = b.senderTerminal || b.receivingTerminal || 0;
        return aTerminal - bTerminal;
      });

      // 普通会话按最后发送时间排序
      normalChats.sort((a, b) => {
        const aTime = a.lastSendTime || 0;
        const bTime = b.lastSendTime || 0;
        return bTime - aTime;
      });

      // 构造虚拟的"智能体"聚合会话
      const result = [...terminalChats, ...normalChats];

      // 🔥 修复：始终在列表顶部插入"智能体"聚合条目（无论是否有智能体会话）
      const agentCount = this.currentAgentChats.length;

      // 🔥 新增：获取活跃智能体状态列表（用于轮播）
      const activeAgentStatuses = this.$store.getters.getActiveAgentStatuses || [];

      const activeAgents = activeAgentStatuses.map(statusData => {
        console.log('[Chat.vue] 🔍 处理 statusData:', statusData);

        // 根据 imChatId 查找对应的智能体会话，获取 agentName
        const agentChat = this.chatStore.chats.find(chat =>
          chat.type === 'AGENT' && chat.targetId === statusData.imChatId
        );
        console.log('[Chat.vue] 🔍 找到的 agentChat:', agentChat);

        const mappedAgent = {
          sessionId: statusData.sessionId,
          agentName: statusData.agentName || (agentChat ? agentChat.showName : '未知智能体'),
          statusText: statusData.status?.statusText || '',
          statusColor: statusData.status?.statusColor || '#606266'
        };
        console.log('[Chat.vue] 🔍 映射后的 agent:', mappedAgent);
        return mappedAgent;
      }).filter(agent => {
        const hasStatusText = !!agent.statusText;
        console.log('[Chat.vue] 🔍 过滤判断:', { agent, hasStatusText });
        return hasStatusText;
      });

      const agentAggregateChat = {
        type: 'AGENT_AGGREGATE', // 特殊类型标识
        targetId: '__AGENT_AGGREGATE__',
        showName: '智能体',
        headImage: '', // 空字符串，HeadImage组件会显示默认头像
        lastContent: agentCount > 0 ? `${agentCount} 个会话` : '暂无会话',
        lastSendTime: Date.now(), // 使用当前时间确保排在最前面
        unreadCount: 0,
        messages: [],
        originalIndex: -1, // 特殊索引
        delete: false,
        activeAgents: activeAgents // 🔥 新增：活跃智能体列表（用于轮播组件）
      };
      result.unshift(agentAggregateChat); // 插入到最前面

      return result;
    }
  },
  created() {
    console.log('[Chat] ========== Chat.vue created 钩子执行 ==========');
    console.log('[Chat] 当前路由:', this.$route.path);
    console.log('[Chat] 路由 query:', this.$route.query);
    console.log('[Chat] 是否有 agentId:', !!this.$route.query.agentId);
    console.log('[Chat] 是否有 autoStart:', !!this.$route.query.autoStart);
  },
  beforeMount() {
    console.log('[Chat] ========== Chat.vue beforeMount 钩子执行 ==========');
  },
  mounted() {
    this.loadPendingCount();
    console.log('[Chat] ========== Chat.vue mounted 钩子执行 ==========');
    console.log('[Chat] 当前路由:', this.$route.path);
    console.log('[Chat] 路由 query:', this.$route.query);

    // 初始化时检测当前活跃会话
    this.detectPCTerminalChat();

    // 确保小龙虾端和云小龙虾端会话存在
    this.ensureTerminalChats();

    // 绑定键盘事件
    document.addEventListener('keydown', this.handleKeyDown);

    // 监听定位到第一个未读会话的事件
    this.$eventBus.$on('locate-first-unread-chat', this.locateFirstUnreadChat);

    // 监听显示智能体列表事件
    this.$bus.$on('show-agent-list', this.handleShowAgentList);

    // 🆕 监听来自 Happy iframe 的 postMessage
    window.addEventListener('message', this.handlePostMessage);
    console.log('[Chat] ========== postMessage 监听器已添加 ==========');
    console.log('[Chat] window 对象存在:', typeof window !== 'undefined');
    console.log('[Chat] 当前 URL:', window.location.href);

    // 🎯 处理智能体分享链接 - 检查URL中的agentId参数
    this.$nextTick(() => {
      this.handleAgentShareLink();
      // 检查是否需要显示智能体列表
      if (this.$route.query.showAgentList === 'true') {
        this.handleShowAgentList();
        // 清除参数
        this.$router.replace({ path: '/home/chat', query: {} });
      }
    });

    // 🔥 永久绑定 overlay 的事件监听器（按照demo）
    this.$nextTick(() => {
      const overlay = document.querySelector('.drag-capture-overlay');
      if (overlay) {
        console.log('[Chat] 🔧 开始绑定 overlay 事件监听器');
        console.log('[Chat] 🔧 overlay 元素:', overlay);
        console.log('[Chat] 🔧 handleOverlayMouseMove 函数:', typeof this.handleOverlayMouseMove);
        console.log('[Chat] 🔧 handleOverlayMouseUp 函数:', typeof this.handleOverlayMouseUp);

        overlay.addEventListener('mousemove', this.handleOverlayMouseMove);
        overlay.addEventListener('mouseup', this.handleOverlayMouseUp);
        console.log('[Chat] ✅ overlay 事件监听器已永久绑定');

        // 🔥 测试：添加一个简单的 mouseup 监听器验证事件是否能被捕获
        overlay.addEventListener('mouseup', (e) => {
          console.log('🔥🔥🔥 [TEST] overlay 原生 mouseup 事件触发!', e.clientX, e.clientY);
        });
      } else {
        console.error('[Chat] ⚠️ 找不到 overlay 元素');
      }
    });
  },
  beforeDestroy() {
    // 清理拖拽事件监听器
    document.removeEventListener('mousemove', this.handleResizerMouseMove);
    document.removeEventListener('mouseup', this.handleResizerMouseUp);

    // 清理键盘事件监听器
    document.removeEventListener('keydown', this.handleKeyDown);

    // 清理事件总线监听器
    this.$eventBus.$off('locate-first-unread-chat', this.locateFirstUnreadChat);
    this.$bus.$off('show-agent-list', this.handleShowAgentList);

    // 🆕 清理 postMessage 监听器
    window.removeEventListener('message', this.handlePostMessage);

    // 🔥 清理 overlay 的事件监听器
    const overlay = document.querySelector('.drag-capture-overlay');
    if (overlay) {
      overlay.removeEventListener('mousemove', this.handleOverlayMouseMove);
      overlay.removeEventListener('mouseup', this.handleOverlayMouseUp);
      console.log('[Chat] ✅ overlay 事件监听器已清理');
    }

    // 🆕 清理拖拽 mousemove 监听器
    if (this.handleGlobalMouseMove) {
      document.removeEventListener('mousemove', this.handleGlobalMouseMove);
    }

    // 取消任何挂起的动画帧
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  },
  watch: {
    // 🔥 监听路由变化 - 处理组件复用场景
    '$route': {
      handler(newRoute, oldRoute) {
        console.log('[Chat] ========== $route watch 触发 ==========');
        console.log('[Chat] 新路由 path:', newRoute.path);
        console.log('[Chat] 新路由 query:', JSON.stringify(newRoute.query));
        console.log('[Chat] 旧路由 path:', oldRoute?.path || '无');
        console.log('[Chat] 旧路由 query:', oldRoute ? JSON.stringify(oldRoute.query) : '无');

        // 🔥 检测是否有智能体参数
        const hasAgentParams = newRoute.query.agentId && newRoute.query.autoStart === 'true';
        console.log('[Chat] - hasAgentParams:', hasAgentParams);

        if (!hasAgentParams) {
          console.log('[Chat] - 没有智能体参数，跳过');
          return;
        }

        // 🔥 检测是否是路由参数变化（不是首次挂载）
        if (oldRoute) {
          const agentIdChanged = oldRoute.query.agentId !== newRoute.query.agentId;
          const autoStartChanged = oldRoute.query.autoStart !== newRoute.query.autoStart;
          const pathChanged = oldRoute.path !== newRoute.path;

          console.log('[Chat] - pathChanged:', pathChanged);
          console.log('[Chat] - agentIdChanged:', agentIdChanged);
          console.log('[Chat] - autoStartChanged:', autoStartChanged);

          const isRouteChanged = pathChanged || agentIdChanged || autoStartChanged;
          console.log('[Chat] - isRouteChanged:', isRouteChanged);

          if (isRouteChanged) {
            console.log('[Chat] 🎯 检测到路由参数变化，触发智能体初始化');
            this.$nextTick(() => {
              this.handleAgentShareLink();
            });
          } else {
            console.log('[Chat] - 路由参数未变化，跳过');
          }
        } else {
          console.log('[Chat] - oldRoute 为空，这是首次渲染（应该由 mounted 处理）');
        }
      },
      immediate: false  // 不需要immediate，因为mounted已经处理了首次进入
    },

    'chatStore.activeChat': {
      handler(newChat) {
        // 当活跃会话改变时，重新检测
        this.detectPCTerminalChat();

        // ✨ 如果激活的是智能体会话，自动切换到二级面板
        if (newChat && (newChat.type === 'AGENT' || (newChat.targetId && newChat.targetId.toString().includes('agent_')))) {
          // 只有在当前不在智能体列表视图时才切换
          if (this.viewMode !== 'agent-list') {
            console.log('[Chat] 检测到智能体会话激活，自动切换到二级面板:', newChat.showName);
            this.enterAgentListView(null, -1);
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  position: relative;

  // 🔥 移动端全屏模式
  &.mobile-fullscreen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    overflow: visible !important;

    .chat-list-box {
      display: none !important;
      width: 0 !important;
    }

    .chat-box {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      overflow: visible !important;
    }
  }

  // 🔥 拖拽捕获层 - 参考 demo 实现
  .drag-capture-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000; // 🔑 降低z-index，让iframe能在上面
    background-color: transparent;
    pointer-events: none; // 默认不拦截事件

    &.active {
      pointer-events: auto; // 拖拽时激活，拦截所有事件
      cursor: copy;
      background-color: rgba(0, 0, 0, 0.02); // 🔥 添加微弱背景色用于调试
    }
  }

  .chat-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);
    position: relative; // 为分隔条的绝对定位提供参考
    will-change: width; // 提示浏览器优化宽度变化

    .chat-list-header {
      height: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 8px;
      gap: 8px;

      .app-title {
        font-size: 18px;
        font-weight: 700;
        color: #303133;
        letter-spacing: 0.5px;
        text-align: center;
        margin: 0;
        padding: 4px 0;
      }
    }

    .chat-list-loading {
      height: 50px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    // ===== 滑动容器样式 =====
    .chat-list-container {
      flex: 1;
      position: relative;
      overflow: hidden; // 隐藏滑出的内容
    }

    // 主列表视图
    .main-list-view {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      // GPU 硬件加速
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      will-change: transform, opacity;
      // 过渡动画 - 类似微信的缓动曲线
      transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);

      // 滑出状态
      &.sliding-out {
        transform: translate3d(-100%, 0, 0);
        opacity: 0;
      }

      .chat-list-items {
        height: 100%;
      }
    }

    // 智能体列表视图
    .agent-list-view {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // 初始状态：在右侧待命
      transform: translate3d(100%, 0, 0);
      opacity: 0;
      // GPU 硬件加速
      backface-visibility: hidden;
      will-change: transform, opacity;
      // 过渡动画
      transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      // 左侧阴影增强层次感
      box-shadow: -4px 0 12px rgba(0, 0, 0, 0);
      transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  opacity 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  box-shadow 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);

      // 激活状态：滑入可见区域
      &.active {
        transform: translate3d(0, 0, 0);
        opacity: 1;
        box-shadow: -4px 0 12px rgba(0, 0, 0, 0.08);
      }

      // 返回头部 - 简洁风格，左对齐
      .back-header {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 5px;
        background: var(--im-background);
        border-bottom: 1px solid #EBEEF5;
        color: #303133;
        cursor: pointer;
        user-select: none;
        transition: background 0.2s ease;
        // 硬件加速
        transform: translateZ(0);

        &:hover {
          background: #f5f7fa;
        }

        &:active {
          background: #e8ecf1;
        }

        i {
          font-size: 16px;
          margin-right: 8px;
          color: #606266;
        }

        .parent-chat-name {
          font-size: 15px;
          font-weight: 500;
          color: #303133;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
      }

      // 智能体列表区域
      .agent-chat-items {
        flex: 1;
        background: var(--im-background);

        // 动画期间隐藏滚动条
        &.hide-scrollbar {
          ::v-deep .el-scrollbar__bar {
            opacity: 0 !important;
          }
        }

        // 统一滚动条样式（与 happy 项目一致）
        ::v-deep .el-scrollbar__wrap {
          overflow-y: scroll;
          scrollbar-gutter: stable; // 为滚动条保留稳定空间

          // Webkit 滚动条（Chrome, Safari, Edge）
          &::-webkit-scrollbar {
            width: 12px;
            height: 12px;
          }

          &::-webkit-scrollbar-track {
            background: #F8F8F8; // happy 项目的 surfaceHigh 颜色
            border-radius: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #f0f0f0; // happy 项目的 surfaceHighest 颜色（更浅）
            border-radius: 6px;
            border: 2px solid transparent;
            background-clip: padding-box;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #EAEAEA; // happy 项目的 divider 颜色
            background-clip: padding-box;
          }

          &::-webkit-scrollbar-corner {
            background: #F8F8F8;
          }

          // Firefox 浏览器
          scrollbar-width: thin;
          scrollbar-color: #f0f0f0 #F8F8F8;
        }
      }

      // 智能体列表项样式
      .agent-chat-item {
        // 添加透明border以防止激活时位置窜动
        border-left: 3px solid transparent;
        // 调整padding保持与激活状态一致
        padding-left: 5px !important;

        // 激活状态只改变border颜色，不改变尺寸
        &.active {
          border-left-color: #409EFF;
          padding-left: 5px !important;
        }
      }

      // 空状态引导
      .empty-agent-guide {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        text-align: center;

        .empty-icon {
          font-size: 64px;
          margin-bottom: 16px;
          opacity: 0.6;
        }

        .empty-text {
          font-size: 14px;
          color: #909399;
          margin-bottom: 20px;
        }

        .add-agent-btn {
          min-width: 140px;
        }
      }
    }

    .chat-list-items {
      flex: 1;

      // 动画期间隐藏滚动条
      &.hide-scrollbar {
        ::v-deep .el-scrollbar__bar {
          opacity: 0 !important;
        }
      }

      // 统一滚动条样式（与 happy 项目一致）
      ::v-deep .el-scrollbar__wrap {
        overflow-y: scroll;
        scrollbar-gutter: stable; // 为滚动条保留稳定空间

        // Webkit 滚动条（Chrome, Safari, Edge）
        &::-webkit-scrollbar {
          width: 12px;
          height: 12px;
        }

        &::-webkit-scrollbar-track {
          background: #F8F8F8; // happy 项目的 surfaceHigh 颜色
          border-radius: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #f0f0f0; // happy 项目的 surfaceHighest 颜色（更浅）
          border-radius: 6px;
          border: 2px solid transparent;
          background-clip: padding-box;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #EAEAEA; // happy 项目的 divider 颜色
          background-clip: padding-box;
        }

        &::-webkit-scrollbar-corner {
          background: #F8F8F8;
        }

        // Firefox 浏览器
        scrollbar-width: thin;
        scrollbar-color: #f0f0f0 #F8F8F8;
      }

      // 终端会话样式
      ::v-deep .terminal-chat {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-left: 3px solid #667eea;

        .chat-item-wrapper {
          background: rgba(255, 255, 255, 0.95);
        }

        &:hover {
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
        }

        // 添加终端标识图标
        &::before {
          content: "🖥️";
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          opacity: 0.7;
        }
      }

      // 普通会话样式
      ::v-deep .normal-chat {
        background: #fff;

        &:hover {
          background: #f5f7fa;
        }
      }

      // 终端会话激活状态
      ::v-deep .terminal-chat.active {
        border-left: 3px solid #FFC107;
        box-shadow: inset 0 0 8px rgba(255, 193, 7, 0.2);
      }
    }

    // 分隔条样式 - 参考 happy 项目的实现
    .sidebar-resizer {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 8px;
      z-index: 1000;
      cursor: col-resize;
      display: flex;
      align-items: center;
      justify-content: center;

      .resizer-line {
        position: absolute;
        width: 2px;
        height: 100%;
        background-color: transparent;
        transition: background-color 0.2s ease;
      }

      // 三个小点手柄 - 始终显示
      .resizer-handle {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 3px;
        z-index: 1;

        .resizer-dot {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.2);
          transition: background-color 0.2s ease;
        }
      }

      // 悬停状态
      &.resizer-hovered {
        .resizer-line {
          background-color: #2BACCC;
        }

        .resizer-dot {
          background-color: #2BACCC;
        }
      }

      // 拖拽状态
      &.resizer-dragging {
        .resizer-line {
          background-color: #2BACCC;
          transition: none; // 拖拽时禁用过渡动画
        }

        .resizer-dot {
          background-color: #2BACCC;
          transition: none;
        }
      }
    }
  }

  // 右侧聊天框容器
  .chat-box {
    position: relative;
    // 启用硬件加速，优化宽度变化性能
    will-change: width;
    transform: translateZ(0);
    backface-visibility: hidden;

    // 拖拽时禁用指针事件，防止 iframe 捕获鼠标事件
    &.disable-pointer-events {
      pointer-events: none;

      // 保持分隔条可交互
      .sidebar-resizer {
        pointer-events: auto;
      }
    }
  }

  // 拖拽遮罩层 - 覆盖整个页面，防止 iframe 捕获鼠标事件
  .drag-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999; // 低于分隔条（1000），但高于其他内容
    background-color: transparent;
    cursor: col-resize;
    user-select: none;
  }
}

// 激活状态样式 - 使用全局样式确保生效
.chat-item.active {
  background-color: #E3F2FD !important;
  border-left: 3px solid #409EFF !important;
  padding-left: 7px !important;
  box-shadow: inset 0 0 8px rgba(64, 158, 255, 0.15) !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .chat-page {
    flex-direction: column !important;

    .chat-list-box {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      flex: none;
      height: auto;
      max-height: 40vh;
      border-right: none !important;
      border-bottom: 1px solid #e8e8e8;
    }

    .chat-box {
      flex: 1;
      width: 100% !important;
      min-height: 0;
    }
  }
}

</style>
